import React from 'react'
import classnames from 'classnames'
import "./styles.scss";

export default (props) => {
  const {heading, children, imgOverlay } = props;

  // for boolean attributes, we need to do an in operator test.
  const noContentBelow = 'noContentBelow' in props;

  const classNamesWithVariants = classnames("page-hero", {
    'page-hero--no-content-below': noContentBelow,
    'page-hero--no-heading': !heading
  });

  return (
    <div className={classNamesWithVariants}>
      <div className="page-hero__hero-img" aria-label={heading || "Hero Image"} title={heading || "Hero Image"} alt={heading || "Hero Image"}>
        {imgOverlay && React.cloneElement(imgOverlay, {
          className: imgOverlay.props.className + " page-hero__img-overlay"
        })}
      </div>
      <div className="page-hero__content">
        {heading &&
          <h1 className="page-hero__heading" dangerouslySetInnerHTML={{__html: headingHtml(heading)}}></h1>}
        {/* Note: each child here should be a PageHeroContentSection component */}
        {children}
      </div>
    </div>
  );
}


function headingHtml(headingText) {
  const words = headingText.split(' ');
  const firstWord = words.shift(); // edits words in place to remove first.

  return `<span class="page-hero__heading-first-word">${firstWord}</span> ` + words.join(' ');
}



// WEBPACK FOOTER //
// ./client/components/PageHero/index.js